import createBroadcastChannel, {
  BroadcastChannels,
} from '@platform-ui-common/utilities/broadcastChannel.js';
import useLogout from './useLogout.js';

export default function useLogoutChannel() {
  const logoutChannel = createBroadcastChannel(BroadcastChannels.Logout);
  const { logout } = useLogout();
  logoutChannel.onmessage = () => {
    logout();
    logoutChannel.close();
  };
}
